import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { domain } from '../common/domain';

function Commission() {
  const [commissions, setCommissions] = useState([]);
  const [startGrams, setStartGrams] = useState('');
  const [endGrams, setEndGrams] = useState('');
  const [commissionPerGram, setCommissionPerGram] = useState('');

  useEffect(() => {
    fetchCommissions();
  }, []);

  const fetchCommissions = async () => {
    try {
      const response = await axios.get(`${domain()}?endpoint=commission`);
      setCommissions(response.data);
    } catch (error) {
      console.error('Error fetching commissions:', error);
    }
  };

  const handleAddCommission = async () => {
    if (!startGrams || !endGrams || !commissionPerGram) {
      alert("Please fill all fields.");
      return;
    }
    if (parseFloat(startGrams) >= parseFloat(endGrams)) {
      alert("Start Grams must be less than End Grams.");
      return;
    }
    try {
      const formData = new FormData();
      formData.append('from_grams', startGrams);
      formData.append('to_grams', endGrams);
      formData.append('commission_per_gram', commissionPerGram);
      await axios.post(`${domain()}?endpoint=commission`, formData);
      setStartGrams('');
      setEndGrams('');
      setCommissionPerGram('');
      fetchCommissions();
    } catch (error) {
      console.error('Error adding gram-based commission:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${domain()}?endpoint=commission&id=${id}`);
      fetchCommissions();
    } catch (error) {
      console.error('Error deleting commission:', error);
    }
  };

  const handleEdit = (index) => {
    const updated = commissions.map((item, i) =>
      i === index ? { ...item, isEditing: !item.isEditing } : item
    );
    setCommissions(updated);
  };

  const handleSave = async (id, item) => {
    if (!item.from_grams || !item.to_grams || !item.commission_per_gram) {
      alert("All fields are required.");
      return;
    }
    if (parseFloat(item.from_grams) >= parseFloat(item.to_grams)) {
      alert("Start Grams must be less than End Grams.");
      return;
    }
    try {
      const formData = new FormData();
      formData.append('from_grams', item.from_grams);
      formData.append('to_grams', item.to_grams);
      formData.append('commission_per_gram', item.commission_per_gram);
      formData.append('_method', 'PUT');
      await axios.post(`${domain()}?endpoint=commission&id=${id}&_method=PUT`, formData);
      fetchCommissions();
    } catch (error) {
      console.error('Error updating gram-based commission:', error);
    }
  };

  const handleInputChange = (index, field, value) => {
    const updated = commissions.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    setCommissions(updated);
  };

  return (
    <div className="p-3 bg-light text-dark rounded mt-4" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <h5 className="mb-3 text-center">Commission Settings (Gram Based Only)</h5>
      <div className="d-flex mb-2">
        <input
          type="number"
          className="form-control form-control-sm me-2"
          placeholder="Start Grams"
          value={startGrams}
          onChange={(e) => setStartGrams(e.target.value)}
        />
        <input
          type="number"
          className="form-control form-control-sm me-2"
          placeholder="End Grams"
          value={endGrams}
          onChange={(e) => setEndGrams(e.target.value)}
        />
        <input
          type="number"
          className="form-control form-control-sm me-2"
          placeholder="Commission/Gram"
          value={commissionPerGram}
          onChange={(e) => setCommissionPerGram(e.target.value)}
        />
        <button className="btn btn-sm btn-primary" onClick={handleAddCommission}>
          Add
        </button>
      </div>
      <table className="table table-sm table-bordered text-center">
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>Start Grams</th>
            <th>End Grams</th>
            <th>Commission/Gram</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {commissions.length > 0 ? (
            commissions.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>
                  {item.isEditing ? (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={item.from_grams || ''}
                      onChange={(e) => handleInputChange(index, 'from_grams', e.target.value)}
                    />
                  ) : (
                    item.from_grams || ''
                  )}
                </td>
                <td>
                  {item.isEditing ? (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={item.to_grams || ''}
                      onChange={(e) => handleInputChange(index, 'to_grams', e.target.value)}
                    />
                  ) : (
                    item.to_grams || ''
                  )}
                </td>
                <td>
                  {item.isEditing ? (
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      value={item.commission_per_gram || ''}
                      onChange={(e) => handleInputChange(index, 'commission_per_gram', e.target.value)}
                    />
                  ) : (
                    item.commission_per_gram || ''
                  )}
                </td>
                <td>
                  {item.isEditing ? (
                    <button
                      className="btn btn-sm btn-success me-1"
                      onClick={() => handleSave(item.id, item)}
                    >
                      Save
                    </button>
                  ) : (
                    <button
                      className="btn btn-sm btn-warning me-1"
                      onClick={() => handleEdit(index)}
                    >
                      Edit
                    </button>
                  )}
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(item.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-muted">
                No commission records found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default Commission;
